export default "__VITE_ASSET__CLQxPZ33__"